export default "__VITE_ASSET__DecNJLZb__"